import React from 'react';
import { Form, Button } from 'antd';
import { useAuth } from 'context/authContext';
import { openUrlWithRole } from 'utils/helpers';

export const SmallButton = ({
  href,
  icon,
  label,
  disabled,
  className,
  btnClassName,
  target,
  ...props
}) => {
  const { role } = useAuth();

  const handleClick = (e) => {
    if (href && target === '_blank') {
      e.preventDefault();
      openUrlWithRole(href, role);
      return;
    }

    if (props.onClick) props.onClick(e);
  };

  const buttonProps = { type: 'primary', htmlType: 'button', disabled, className: btnClassName };

  // When target is _blank we avoid passing href to let our click handler control opening
  if (!href || target === '_blank') {
    return (
      <Form.Item className={className}>
        <Button {...buttonProps} onClick={handleClick} {...props}>
          {icon}
          {label}
        </Button>
      </Form.Item>
    );
  }

  return (
    <Form.Item className={className}>
      <Button href={href} {...buttonProps} {...props}>
        {icon}
        {label}
      </Button>
    </Form.Item>
  );
};
